module.exports = __webpack_public_path__ + "static/resume-ed75bbbe1cbd561029acff347e96811c.png";